<template>
  <div id="app">
<!--    <particles />-->
    <router-view/>
  </div>
</template>
<script>
// import particles from '@/components/particles.vue'
export default {
	name: 'App',
	components: {
		// particles
	},
	mounted() {

	},
}


</script>

<style lang="scss">

#snow {
	position: fixed;
	top: -96px;
	left: 0;
	right: 0;
	bottom: 0;

	canvas {
		width: 100% !important;
		height: 100% !important;
	}

}

html {
  font-size: 16px;
  /* mobile */
  @media screen and (min-width: 320px) and (max-width: 375px) {
    font-size: calc(84.38% + 2 * (100vw - 375px) / 39);
    font-size: calc(13.5px + 2 * (100vw - 320px) / 55);
  }
  @media screen and (min-width: 375px) and (max-width: 414px) {
    font-size: calc(100% + 2 * (100vw - 375px) / 39);
    font-size: calc(16px + 2 * (100vw - 375px) / 39);
  }
  @media screen and (min-width: 414px) and (max-width: 600px) {
    font-size: calc(112.5% + 4 * (100vw - 414px) / 186);
    font-size: calc(18px + 4 * (100vw - 414px) / 186);
  }
  @media screen and (min-width: 600px) {
    font-size: 26px;
  }

  /* 平板 */
  @media (min-device-width : 768px) and (max-device-width : 1024px) and (orientation : portrait),
         (min-device-width : 768px) and (max-device-width : 1024px) and (orientation : landscape) {
    font-size: calc(15px + 5 * (100vw - 768px) / 256);
    body {
       min-width: 100%;
    }
  }

  /* pc */
  @media screen and (min-width: 1320px) {
    font-size: calc(162.5% + 12 * (100vw - 1320px) / 600);
    font-size: calc(26px + 12 * (100vw - 1320px) / 600);
  }
  @media screen and (min-width: 1920px) {
    // 每100px fontSize增加0.5px
    font-size: calc(237.5% + 5 * (100vw - 1920px) / 1000);
    font-size: calc(38px + 5 * (100vw - 1920px) / 1000);
  }
}
body {
  margin: 0;
  width: 100%;
  min-width: 1320px;
  background: #efefef;
  line-height: 1;
  @media screen and (max-width: 600px) {
    min-width: 100%;
  }
  ::selection {
      color:#fff;
      background-color: #D89BDD;
  }
  img {
    @include userSelect;
  }
}
.no_touch{
  overflow: hidden;
}
#app {
  font-family: Arial, "Helvetica Neue", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Helvetica, Verdana, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>
